import * as React from 'react';
import Button from "antd/es/button";
import { useEffect, useState } from "react";
import { Col, Form, Row } from "antd";
import { LabeledValue } from "antd/es/select";
import MultipleChoicesSelect, { MultipleChoicesSelectProps } from "./MultipleChoicesSelect";
import { EditedUser } from "../../Pages/Admin/Contracts/AdminContractEditionPage";

interface MultipleSelectWithTableProps extends MultipleChoicesSelectProps {
  selectDataSource?: LabeledValue[];
  name: string;
  initialValues?: any;
  template: any;
  onAdd?: Function;
  onRemove?: Function;
  onEdition?: Function;
  placeholder?: string;
  transformers?: Function[]
}

export interface MultipleSelectWithTableValue extends LabeledValue {
  id?: any;
  value: any;
}

export interface MultipleSelectTableProps {
  dataSource: any[];
  onRemove?: Function;
  onEdition?: Function;
}

export function MultipleChoicesWithTable(props: MultipleSelectWithTableProps) {
  const {
    selectDataSource,
    onSearch,
    placeholder,
    onRemove,
    onEdition,
    onAdd,
    name,
    initialValues,
    template,
  } = props;
  const [selectedValues, setSelectedValues] = useState<MultipleSelectWithTableValue[]>(initialValues ? initialValues : []);
  const [currentValue, setCurrentValue] = useState<MultipleSelectWithTableValue|undefined>(undefined);
  const formRef = Form.useFormInstance();

  useEffect(() => {
    updateForm(selectedValues);
  }, [selectedValues])

  const updateForm = (selectedValues: MultipleSelectWithTableValue[]) => {
    const { transformers } = props;
    if (formRef) {
      formRef && formRef.setFieldsValue({
        [name]: selectedValues.map((current) => {
          // if no value transformers are set, just return item value
          if (!transformers) {
            return current.value;
          }

          // if value transformers are set, let them work before
          let processedValue = JSON.parse(JSON.stringify(current))
          for (const transformer of transformers) {
            processedValue = transformer && transformer(processedValue);
          }
          return processedValue;
        })
      });
    }
  }

  const onValueAdded = () => {
    if (!currentValue) {
      return;
    }

    // checking if value has already been added before
    const filteredValues = selectedValues.filter((item) => {
      return String(item.id) === String(currentValue.id)
    });

    // if not, add it
    if (filteredValues.length === 0) {
      selectedValues.push(currentValue);
      setSelectedValues(selectedValues);
      updateForm(selectedValues);
      onAdd && onAdd(currentValue);
    }
  };

  const onValueRemoved = async (value: MultipleSelectWithTableValue) => {
    // removing value by filtering selectedValues
    const filteredValues = selectedValues.filter(item => String(item.id) !== String(value.id));
    await setSelectedValues(filteredValues);
    updateForm(filteredValues);
  };

  const Template = template;
  return (
    <div>
      <Row style={{ marginBottom: '20px' }}>
        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }}>
          <div style={{ display: 'inline-block', width: '80%' }}>
            <MultipleChoicesSelect
              placeholder={placeholder}
              onValueSelected={(value: LabeledValue) => {
                setCurrentValue(value);
              }}
              onSearch={onSearch}
              initialDataSource={selectDataSource && selectDataSource.map((item: MultipleSelectWithTableValue) => {
                return {
                  value: item.value,
                  label: item.label,
                  id: item.id
                }
              })}
            />
          </div>
          <div style={{ display: 'inline-block' }}>
            <Button
              type={"link"}
              onClick={onValueAdded}
            >
              Add
            </Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Template
            dataSource={[...selectedValues]}
            onEdition={(editedUser: EditedUser) => {
              onEdition && onEdition(editedUser, selectedValues, setSelectedValues);
            }}
            onRemove={async (value: MultipleSelectWithTableValue) => {
              onRemove && await onRemove(value);
              onValueRemoved(value);
            }}
          />
        </Col>
      </Row>
    </div>
  );
}